import { Divider, useTheme, useMediaQuery } from '@mui/material';

export const ResponsiveDivider = () => {
  const theme = useTheme();
  const isSmallUp = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <Divider
      orientation={isSmallUp ? 'vertical' : 'horizontal'}
      flexItem
      sx={{
        mx: { xs: 0, sm: 2 },
        my: { xs: 1, sm: 0 },
        borderStyle: 'dashed',
      }}
    />
  );
};
